import firebase from "firebase";
import 'firebase/firestore'


var firebaseConfig = {
  apiKey: "AIzaSyDTCwLsZI5Nr1upaLVE1r5ywnw6q85uorQ",
  authDomain: "edgarand-b2cf4.firebaseapp.com",
  projectId: "edgarand-b2cf4",
  storageBucket: "edgarand-b2cf4.appspot.com",
  messagingSenderId: "807438190920",
  appId: "1:807438190920:web:89cf28b9d9cc5b1d5d4b7d",
  measurementId: "G-6Y2F9VYX09",
};
// Initialize Firebase
const fb=firebase.initializeApp(firebaseConfig)
export const db=fb.firestore();




